import { PaddingSystemProps } from '@rover/kibble/core/styledSystemPropTypes';

/** Common props for BottomSheet across web and native */
export type BottomSheetCommonProps = {
  /** Content to display in the bottom sheet */
  children: React.ReactNode;
  /** Controls bottom sheet visibility */
  isOpen: boolean;
  /** Hide the close (X) icon */
  hideCloseIcon?: boolean;
  /** Allow closing by dragging down */
  closeOnDragDown?: boolean;
  /** Allow dismissing by clicking overlay or pressing escape */
  isDismissible?: boolean;
  /** Custom padding for content area */
  contentPaddingStyles?: Partial<PaddingSystemProps>;
  /** Callback when bottom sheet is closed */
  onRequestClose: (payload?: unknown) => void;
  /** Optional header content at top of sheet */
  HeaderComponent?: React.ReactNode;
};

/** Default horizontal padding for bottom sheet content */
export const defaultContentPaddingStyles: Partial<PaddingSystemProps> = { paddingX: '4x' };

/** Props for dismiss button component */
export type DismissButtonProps = Pick<
  BottomSheetCommonProps,
  'isDismissible' | 'hideCloseIcon' | 'onRequestClose' | 'closeOnDragDown'
>;
